import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CONSULTATION_BOOKING_LINK } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { Calendar, Star } from "lucide-react";

const content = {
  "email-health": {
    title:
      "Fix Spam Issues Fast – Get 1:1 Help from Our Deliverability Experts – Limited Slots Available",
    description:
      "A weak setup — missing SPF, DKIM, or DMARC records, blacklisted IPs, or poor content structure — could quietly ruin your deliverability. Book a call and let out experts identify red flags, fix hidden issues, and protect your sender score before it's too late",
  },
  "inbox-placement": {
    title:
      "Struggling with Inboxing? Book Your Free 1:1 Call to Fix It – Limited Slots Available",
    description:
      "Inbox placement is more than just hitting “send” — it’s about making sure your emails actually get seen. Get actionable strategies to stop your emails from hitting spam folders and boost inbox placement.",
  },
};

const ConsultationBanner = ({
  type,
  className,
}: {
  type: "email-health" | "inbox-placement";
  className?: string;
}) => {
  return (
    <Card
      className={cn(
        "overflow-hidden border-primary/50 bg-background group relative",
        className
      )}
    >
      <img
        src="/circle-grid.png"
        alt="Consultation Banner"
        width={600}
        height={600}
        className="absolute scale-125 md:scale-100 top-0 translate-y-[-40%] left-1/2 -translate-x-1/2 md:left-0 md:top-1/2  md:-translate-y-1/2 md:translate-x-[-30%]"
      />
      <img
        src="/circle-grid.png"
        alt="Consultation Banner"
        width={600}
        height={600}
        className="absolute top-1/2 -translate-y-1/2  right-0 translate-x-[30%] hidden md:block"
      />
      <CardContent className="p-4 px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-stretch md:gap-4">
          <div className="p-4 md:p-6 md:aspect-square flex items-center justify-center">
            <img
              src="/consulting-3d.png"
              alt="Consultation Banner"
              width={150}
              height={150}
              className="rounded-md  object-cover scale-150"
            />
          </div>
          <div className="flex-1 p-4 flex items-center">
            {/* Content */}
            <div className="flex-1 space-y-6">
              <div className="max-w-[1000px]">
                <h3 className="text-2xl font-semibold text-foreground mb-2">
                  {content[type].title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {content[type].description}
                </p>
              </div>

              {/* Call to action */}
              <div className="flex flex-col md:flex-row gap-4 items-center">
                <a
                  href={CONSULTATION_BOOKING_LINK}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Button className="gap-2 transition-colors text-base h-10 px-5 w-full md:w-auto">
                    <Calendar size={18} className="mr-1" />
                    Schedule a 1-hour call
                  </Button>
                </a>
                <div className=" flex flex-col lg:flex-row items-center gap-2 text-muted-foreground font-medium w-full lg:w-auto text-center lg:text-left">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-4 h-4 fill-yellow-400 text-yellow-400"
                      />
                    ))}
                  </div>
                  <span>We have assisted 500+ businesses</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ConsultationBanner;
